let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aYt2K")).then(() => parcelRequire('jIHto'));